import moment from 'moment';

export function formatDateToStandard(date: Date | string): string {
    return moment(date).format('YYYY-MM-DD');
}

export function formatDate(date: Date | string, pattern: string): string {
    return moment(date).format(pattern);
}